import React from 'react';
import { shape, arrayOf, func, string, bool, oneOf, oneOfType, number } from 'prop-types';
import Icon from 'components/icon';
import { FILTER_TYPE_SINGLE_CHECKBOX } from '../constants/filter-types';

export default function ActiveFiltersSection({
    activeFiltersStyle, activeFiltersLabel, activeFilters,
    showActiveFilters, resetFilters, toggleFilters, noItemsText
}) {
    if (!activeFilters.length || !showActiveFilters) { return null; }

    return (
        <div className={`active-filters-section ${activeFiltersStyle}`}>
            <div className="active-filters-container">
                <div className="active-filters">
                    { activeFiltersLabel && <div className="active-filter-heading"><small>{activeFiltersLabel}</small></div>}

                    {activeFilters.map(filter => (
                        filter.values.map(value => (
                            <div
                                className="active-filter-item"
                                key={`${filter.code}-${value}`}
                                onClick={e => toggleFilters(e, filter, value, true)}
                                onKeyPress={e => toggleFilters(e, filter, value, true)}
                                role="button"
                                tabIndex="0"
                            >
                                <Icon glyph="cross" />
                                <span>{filter.type === FILTER_TYPE_SINGLE_CHECKBOX ? filter.label : value.replace('||', ' - ')}</span>
                            </div>
                        ))
                    ))}

                    <span className="active-filter-reset">
                        <small
                            className="btn-text"
                            onClick={resetFilters}
                            onKeyPress={resetFilters}
                            role="button"
                            tabIndex="0"
                        >
                            {noItemsText}
                        </small>
                    </span>
                </div>
            </div>
        </div>
    );
}

ActiveFiltersSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    activeFiltersStyle: oneOf(['btn-tags', 'text-list']).isRequired,
    activeFiltersLabel: string.isRequired,
    activeFilters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number])).isRequired
    })).isRequired,
    showActiveFilters: bool.isRequired,
    resetFilters: func.isRequired,
    toggleFilters: func.isRequired,
    noItemsText: string.isRequired
    /* eslint-enable react/no-typos */
};
